import { mdbContainer, mdbRow, mdbCol, mdbCardBody, mdbCard } from "mdbvue";
import { mapActions, mapGetters } from "vuex";
import Btn from "../../../../core/Button";
import Popup from "../../../../core/Popup";
import Swal from "sweetalert2";
import { required } from "vuelidate/lib/validators";
import ValidationError from "../../../misc/ValidationError";
import vSelect from "vue-select";
import Loader from "../../../../core/Loader";

const ParticipantsAndRecommendations = {
    name: "ParticipantsAndRecommendations",
    components: {
        isLoading: true,
        "v-select": vSelect,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCardBody,
        mdbCard,
        Btn,
        Popup,
        ValidationError,
        Loader
    },
    data() {
        return {
            isLoading: true,
            listCommitteeVotes: [1,2,3,4,5,6,7,8,9,10],
            listPartnerRecommendations: [1,2,3,4,5,6,7,8,9,10],
            partnerRecommendations: "",
            committeeVotes: "",
        };
    },
    validations: {
        partnerRecommendations: {
            required
        },
        committeeVotes: {
            required
        },
    },
    methods: {
        ...mapActions([
            "_setPartnerRecommendations",
            "_setCommitteeVotes",
            "_getPartnerRecommendations",
            "_getCommitteeVotes",
        ]),
        pushNotifyError(){
            this.$notify.error({
                message: "Ha ocurrido un error, inténtalo más tarde.",
                position: "top right",
                timeOut: 15000
            });
        },
        async getPartnerRecommendations(){
            try {
                this.isLoading = true;
                const { data } = await this._getPartnerRecommendations();
                if (data.status === 200) {
                    const { data: partnerRecommendations } = data;
                    this.partnerRecommendations = partnerRecommendations;
                }else{
                    this.pushNotifyError();
                }
            } catch (error) {
                this.pushNotifyError();
            } finally {
                this.isLoading = false;
            }
        },
        async getCommitteeVotes(){
            try {
                this.isLoading = true;
                const { data } = await this._getCommitteeVotes();
                if (data.status === 200) {
                    const { data: committeeVotes } = data;
                    this.committeeVotes = committeeVotes;
                }else{
                    this.pushNotifyError();
                }
            } catch (error) {
                this.pushNotifyError();
            } finally {
                this.isLoading = false;
            }
        },
        async setCommitteeVotes(){
            try {
                this.isLoading = true;
                const { data } = await this._setCommitteeVotes({
                    committeeVotes: this.committeeVotes
                });
                if (!(data.status === 200)) {
                    this.pushNotifyError();
                }else{
                    this.alertSuccess('El número de participantes de Comité ha sido guardado.')
                }
            } catch (error) {
                this.pushNotifyError();
            } finally {
                this.isLoading = false;
            }
        },
        async setPartnerRecommendations(){
            try {
                this.isLoading = true;
                const { data } = await this._setPartnerRecommendations({
                    partnerRecommendations: this.partnerRecommendations
                });
                if (!(data.status === 200)) {
                    this.pushNotifyError();
                }else{
                    this.alertSuccess('El número de recomendaciones de socios ha sido guardado.')
                }
            } catch (error) {
                this.pushNotifyError();
            } finally {
                this.isLoading = false;
            }
        },
        alertSuccess(message) {
            Swal.fire({
                title:
                    " <span style='font-family: Josefin Sans,serif; font-size: 22px; font-weight: 600; color: #828282; font-stretch: normal; font-style: normal; line-height: normal;letter-spacing: normal;'>GUARDADO CORRECTAMENTE</span>",
                html:
                    "<div>" +
                    `<span class='mt-2'  style='font-family: Open Sans; font-size: 14px; color: #828282; font-weight: normal'>${message}</span>` +
                    "<img alt='success_icon' src='/img/icons/ok.svg' style='width: 40%; margin-top: 1rem;' />" +
                    "</div>",
                width: "55rem",
                padding: "5rem",
                showConfirmButton: false,
                showCloseButton: true
            });
        },
        errorMessage() {
            Swal.fire({
                title:
                    "<span style='font-size: 25px; font-weight: 600; margin-top: 1rem;margin-bottom: -1rem; font-family: Josefin Sans,serif; color: #dc7134'>¡ATENCIÓN!</span>",
                html:
                    "<div style='text-align: center; padding-right: 3rem; padding-left: 3rem; font-size: 16px; font-family: Open Sans,serif' color: #828282'>" +
                    "<p>No ha sido posible registrar el tipo de usuario.</p>" +
                    "<p style='padding-top: 1rem;'> <img src='/img/icons/InoAlerta.svg' alt='Alerta'/> </p>" +
                    "</div>",
                allowOutsideClick: false,
                width: "50rem",
                padding: "2rem",
                confirmButtonText: "Ok",
                confirmButtonColor: "#dc7134",
                customClass: {
                    confirmButton: "t1-btn t1-btn--primary-block"
                },
                onClose: () => {}
            });
        }
    },
    mounted() {
        this.getCommitteeVotes();
        this.getPartnerRecommendations();
    },
    computed: {
        ...mapGetters({
            loginUserType: "getUserType"
        }),
        displayedPost() {
            return this.paginate(this.dataList);
        }
    }
};

export default ParticipantsAndRecommendations;